import { createFileRoute } from '@tanstack/react-router';
import { LoaderDot } from '@thetreep/travel-ui';

import { useMissionWithCase } from '@/domains/mission/hooks/useMissionWithCase';
import { RentalReplacementSearchPage } from '@/features/search/RentalReplacementSearchPage';
import { SearchPage } from '@/features/search/SearchPage';
import { GuaranteeType } from '@/gen/mission/v1/guarantee_pb';

export const Route = createFileRoute('/$missionId/search')({
	component: SearchPageRoute,
	staticData: { restrictScroll: true },
});

function SearchPageRoute() {
	const { missionId } = Route.useParams();
	const {
		mission,
		case: caseData,
		isLoading,
	} = useMissionWithCase({
		missionId,
		searchId: undefined,
		mobilitySolutionId: undefined,
	});

	// Wait for the guarantee type before picking a form -- otherwise a direct/deep-link load
	// would flash the general form before swapping to the replacement-vehicle one.
	if (isLoading) {
		return <LoaderDot className="mt-24 w-full justify-center" />;
	}

	// The replacement-vehicle guarantee only ever allows renting a vehicle from (and
	// returning it to) the same agency -- a much narrower flow than the general
	// multi-transport search, so it gets its own dedicated form.
	if (mission?.guaranteeType === GuaranteeType.REPLACEMENT_VEHICLE) {
		return <RentalReplacementSearchPage missionId={missionId} />;
	}

	return (
		<SearchPage
			missionId={missionId}
			beneficiary={caseData?.beneficiary}
			passengersCount={caseData?.passengersCount}
		/>
	);
}
